import { normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementVNode as _createElementVNode, renderSlot as _renderSlot } from "vue"

const _hoisted_1 = ["alt", "loading", "srcset"]
const _hoisted_2 = ["media", "srcset"]
const _hoisted_3 = ["media", "srcset"]
const _hoisted_4 = ["src", "alt", "loading"]

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    ($options.image)
      ? (_openBlock(), _createElementBlock("img", {
          key: 0,
          class: _normalizeClass(_ctx.$attrs.class),
          style: _normalizeStyle([$options.backgroundStyle, _ctx.$attrs.style]),
          alt: $props.alt,
          height: "auto",
          width: "auto",
          loading: $props.lazyloaded ? 'lazy' : 'eager',
          srcset: $options.image.srcset
        }, null, 14, _hoisted_1))
      : (_openBlock(), _createElementBlock("picture", {
          key: 1,
          class: _normalizeClass(_ctx.$attrs.class)
        }, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($options.imagesMobile, (imageMobile) => {
            return (_openBlock(), _createElementBlock("source", {
              key: imageMobile.srcset,
              media: `(max-width: ${imageMobile.width}px)`,
              srcset: `${imageMobile.srcset} 1x, ${imageMobile.srcsetRetina} 2x`
            }, null, 8, _hoisted_2))
          }), 128)),
          (!$data.isDeviceMobile)
            ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList($options.images, (image, i) => {
                return (_openBlock(), _createElementBlock("source", {
                  key: image.srcset,
                  media: i + 1 !== $options.images.length ? `(max-width: ${image.width}px) ` : '',
                  srcset: `${image.srcset} 1x, ${image.srcsetRetina} 2x`
                }, null, 8, _hoisted_3))
              }), 128))
            : _createCommentVNode("", true),
          _createElementVNode("img", {
            src: $options.mobileImage,
            alt: $props.alt,
            height: "auto",
            width: "auto",
            loading: $props.lazyloaded ? 'lazy' : 'eager',
            class: _normalizeClass(_ctx.$attrs.class),
            style: _normalizeStyle([$options.backgroundStyle, _ctx.$attrs.style])
          }, null, 14, _hoisted_4)
        ], 2)),
    _renderSlot(_ctx.$slots, "default")
  ], 64))
}